import { LogIn, Trophy } from "lucide-react";
import { toast } from "sonner";
import { useJoinCompetitionMutation } from "@/features/predictions/hooks/useJoinCompetitionMutation";

type Props = { competitionName: string };

export const OptedOutBanner = ({ competitionName }: Props) => {
  const joinMutation = useJoinCompetitionMutation();

  const handleJoin = () => {
    joinMutation.mutate(undefined, {
      onSuccess: () => {
        toast.success(`Bienvenue dans ${competitionName} !`);
      },
      onError: () => {
        toast.error("Impossible de rejoindre la compétition pour le moment.");
      },
    });
  };

  return (
    <div className="flex flex-col items-start gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 shadow-sm dark:border-emerald-900 dark:bg-emerald-950/40 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-200">
          <Trophy size={18} aria-hidden />
        </span>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-emerald-900 dark:text-emerald-100">
            Tu es sorti de la compétition
          </p>
          <p className="text-xs text-emerald-800/80 dark:text-emerald-200/80">
            Rejoins
            {" "}
            {competitionName}
            {" "}
            pour pronostiquer à nouveau.
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={handleJoin}
        disabled={joinMutation.isPending}
        className="inline-flex h-10 shrink-0 items-center gap-2 rounded-full bg-emerald-600 px-5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-emerald-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
      >
        <LogIn size={16} aria-hidden />
        {joinMutation.isPending ? "En cours…" : "Rejoindre la compétition"}
      </button>
    </div>
  );
};

OptedOutBanner.displayName = "OptedOutBanner";
